import { Action } from '@ngrx/store';
import { EDocs, EDocsFile, EDocsFolder } from './edocs.models';

export const enum EDocsActionTypes {
  LOAD_EDOCS = '[EDocs] Load eDocs',
  LOAD_EDOCS_FAILED = '[EDocs] Load eDocs failed',
  LOAD_EDOCS_SUCCESS = '[EDocs] Load eDocs success',
  SELECT_FILE = '[EDocs] Select file',
  SELECT_FOLDER = '[EDocs] Select folder',
  CREATE_FILE = '[EDocs] Create file',
  CREATE_FOLDER = '[EDocs] Create folder',
  SAVE_FILE = '[EDocs] Save file',
  SAVE_FILE_FAILED = '[EDocs] Save file failed',
  SAVE_FILE_SUCCESS = '[EDocs] Save file success',
  SAVE_FOLDER = '[EDocs] Save folder',
  SAVE_FOLDER_FAILED = '[EDocs] Save folder failed',
  SAVE_FOLDER_SUCCESS = '[EDocs] Save folder success',
  UPDATE_FILE = '[EDocs] Update file',
  UPDATE_FILE_FAILED = '[EDocs] Update file failed',
  UPDATE_FILE_SUCCESS = '[EDocs] Update file success',
  UPDATE_FOLDER = '[EDocs] Update folder',
  UPDATE_FOLDER_FAILED = '[EDocs] Update folder failed',
  UPDATE_FOLDER_SUCCESS = '[EDocs] Update folder success',
  DELETE_FILE = '[EDocs] Delete file',
  DELETE_FILE_FAILED = '[EDocs] Delete file failed',
  DELETE_FILE_SUCCESS = '[EDocs] Delete file success',
  DELETE_FOLDER = '[EDocs] Delete folder',
  DELETE_FOLDER_FAILED = '[EDocs] Delete folder failed',
  DELETE_FOLDER_SUCCESS = '[EDocs] Delete folder success',
  DOWNLOAD_FILE = '[EDocs] Download file',
  DOWNLOAD_FILE_FAILED = '[EDocs] Download file failed',
  DOWNLOAD_FILE_SUCCESS = '[EDocs] Download file success'
}

export class EDocsActionLoadEDocs implements Action {
  readonly type = EDocsActionTypes.LOAD_EDOCS;
}

export class EDocsActionLoadEDocsFailed implements Action {
  readonly type = EDocsActionTypes.LOAD_EDOCS_FAILED;
}

export class EDocsActionLoadEDocsSuccess implements Action {
  readonly type = EDocsActionTypes.LOAD_EDOCS_SUCCESS;
  constructor(public payload: EDocs) {}
}

export class EDocsActionSelectFile implements Action {
  readonly type = EDocsActionTypes.SELECT_FILE;
  constructor(public payload?: EDocsFile) {}
}

export class EDocsActionSelectFolder implements Action {
  readonly type = EDocsActionTypes.SELECT_FOLDER;
  constructor(public payload?: EDocsFolder) {}
}

export class EDocsActionCreateFile implements Action {
  readonly type = EDocsActionTypes.CREATE_FILE;
}

export class EDocsActionCreateFolder implements Action {
  readonly type = EDocsActionTypes.CREATE_FOLDER;
}

export class EDocsActionSaveFile implements Action {
  readonly type = EDocsActionTypes.SAVE_FILE;
  constructor(
    public payload: {
      file: Partial<EDocsFile>;
      content: string;
      fileName: string;
    }
  ) {}
}

export class EDocsActionSaveFileFailed implements Action {
  readonly type = EDocsActionTypes.SAVE_FILE_FAILED;
}

export class EDocsActionSaveFileSuccess implements Action {
  readonly type = EDocsActionTypes.SAVE_FILE_SUCCESS;
  constructor(public payload: Partial<EDocsFile>) {}
}

export class EDocsActionSaveFolder implements Action {
  readonly type = EDocsActionTypes.SAVE_FOLDER;
  constructor(public payload: Partial<EDocsFolder>) {}
}

export class EDocsActionSaveFolderFailed implements Action {
  readonly type = EDocsActionTypes.SAVE_FOLDER_FAILED;
}

export class EDocsActionSaveFolderSuccess implements Action {
  readonly type = EDocsActionTypes.SAVE_FOLDER_SUCCESS;
  constructor(public payload: Partial<EDocsFolder>) {}
}

export class EDocsActionUpdateFile implements Action {
  readonly type = EDocsActionTypes.UPDATE_FILE;
  constructor(public payload: EDocsFile) {}
}

export class EDocsActionUpdateFileFailed implements Action {
  readonly type = EDocsActionTypes.UPDATE_FILE_FAILED;
}

export class EDocsActionUpdateFileSuccess implements Action {
  readonly type = EDocsActionTypes.UPDATE_FILE_SUCCESS;
  constructor(public payload: EDocsFile) {}
}

export class EDocsActionUpdateFolder implements Action {
  readonly type = EDocsActionTypes.UPDATE_FOLDER;
  constructor(public payload: EDocsFolder) {}
}

export class EDocsActionUpdateFolderFailed implements Action {
  readonly type = EDocsActionTypes.UPDATE_FOLDER_FAILED;
}

export class EDocsActionUpdateFolderSuccess implements Action {
  readonly type = EDocsActionTypes.UPDATE_FOLDER_SUCCESS;
  constructor(public payload: EDocsFolder) {}
}

export class EDocsActionDeleteFile implements Action {
  readonly type = EDocsActionTypes.DELETE_FILE;
  constructor(public payload: EDocsFile) {}
}

export class EDocsActionDeleteFileFailed implements Action {
  readonly type = EDocsActionTypes.DELETE_FILE_FAILED;
}

export class EDocsActionDeleteFileSuccess implements Action {
  readonly type = EDocsActionTypes.DELETE_FILE_SUCCESS;
  constructor(public payload: EDocsFile) {}
}

export class EDocsActionDeleteFolder implements Action {
  readonly type = EDocsActionTypes.DELETE_FOLDER;
  constructor(public payload: EDocsFolder) {}
}

export class EDocsActionDeleteFolderFailed implements Action {
  readonly type = EDocsActionTypes.DELETE_FOLDER_FAILED;
}

export class EDocsActionDeleteFolderSuccess implements Action {
  readonly type = EDocsActionTypes.DELETE_FOLDER_SUCCESS;
  constructor(public payload: EDocsFolder) {}
}

export class EDocsActionDownloadFile implements Action {
  readonly type = EDocsActionTypes.DOWNLOAD_FILE;
  constructor(public payload: EDocsFile) {}
}

export class EDocsActionDownloadFileFailed implements Action {
  readonly type = EDocsActionTypes.DOWNLOAD_FILE_FAILED;
}

export class EDocsActionDownloadFileSuccess implements Action {
  readonly type = EDocsActionTypes.DOWNLOAD_FILE_SUCCESS;
  constructor(public payload: EDocsFile) {}
}

export type EDocsActions =
  | EDocsActionLoadEDocs
  | EDocsActionLoadEDocsFailed
  | EDocsActionLoadEDocsSuccess
  | EDocsActionSelectFile
  | EDocsActionSelectFolder
  | EDocsActionCreateFile
  | EDocsActionCreateFolder
  | EDocsActionSaveFile
  | EDocsActionSaveFileFailed
  | EDocsActionSaveFileSuccess
  | EDocsActionSaveFolder
  | EDocsActionSaveFolderFailed
  | EDocsActionSaveFolderSuccess
  | EDocsActionUpdateFile
  | EDocsActionUpdateFileFailed
  | EDocsActionUpdateFileSuccess
  | EDocsActionUpdateFolder
  | EDocsActionUpdateFolderFailed
  | EDocsActionUpdateFolderSuccess
  | EDocsActionDeleteFile
  | EDocsActionDeleteFileFailed
  | EDocsActionDeleteFileSuccess
  | EDocsActionDeleteFolder
  | EDocsActionDeleteFolderFailed
  | EDocsActionDeleteFolderSuccess
  | EDocsActionDownloadFile
  | EDocsActionDownloadFileFailed
  | EDocsActionDownloadFileSuccess;
